// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"94880a3c","359":"908a2385","361":"660d1b1d"}[chunkId] + ".chunk.js";
};